import React from 'react';
import { brandIconDir, brandName } from '@repo/shared/brand';

interface BrandLogoProps {
    /** Rendered width and height in pixels. */
    size?: number;
}

/**
 * The brand's square logo tile (public/brand/<key>/logo.svg). The SVG carries
 * its own rounded corners and gradient, so it needs no wrapper styling.
 */
export default function BrandLogo({ size = 96 }: BrandLogoProps) {
    return (
        // eslint-disable-next-line @next/next/no-img-element
        <img
            src={`${brandIconDir()}/logo.svg`}
            alt={`${brandName()} logo`}
            width={size}
            height={size}
            style={{ width: size, height: size, display: 'block' }}
        />
    );
}
